import { render, staticRenderFns } from "./PlushieDirectShipmentIntention.vue?vue&type=template&id=1c983992&scoped=true&"
import script from "./PlushieDirectShipmentIntention.vue?vue&type=script&lang=ts&"
export * from "./PlushieDirectShipmentIntention.vue?vue&type=script&lang=ts&"
import style0 from "./PlushieDirectShipmentIntention.vue?vue&type=style&index=0&id=1c983992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c983992",
  null
  
)

export default component.exports